import { useEffect, useState } from 'react';
import { Competition, CompetitionAPI, API } from '@brg/api';
import { useTranslation } from 'react-i18next';

const ZHAR_KNIGA_COMPETITION_ID = '19624f65f36f414abed3891529626052';

let cachedCompetition: Competition | null = null;
let loadPromise: Promise<Competition | null> | null = null;

export const useZharKnigaWinner = (projectId?: string) => {
  const [isWinner, setIsWinner] = useState(false);
  const [position, setPosition] = useState<number | undefined>(undefined);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!projectId) return;

    let cancelled = false;

    const checkIfWinner = (competition: Competition, id: string) => {
      // @ts-ignore
      const winnerPositions = competition?.nominations?.[0]?.winnerPositions || [];
      const winner = winnerPositions.find((w: { winnerId: string; position?: number }) => w.winnerId === id);

      if (winner) {
        setIsWinner(true);
        setPosition(winner.position);
      } else {
        setIsWinner(false);
        setPosition(undefined);
      }
    };

    const checkWinner = async () => {
      if (cachedCompetition) {
        if (!cancelled) checkIfWinner(cachedCompetition, projectId);
        return;
      }

      if (loadPromise) {
        const competition = await loadPromise;
        if (competition && !cancelled) checkIfWinner(competition, projectId);
        return;
      }

      loadPromise = CompetitionAPI.Get({ idCompetition: ZHAR_KNIGA_COMPETITION_ID })
        .then((r) => r.json())
        .then((v) => API.toLang<Competition>(v, i18n.language))
        .then((competition) => {
          cachedCompetition = competition;
          loadPromise = null;
          return competition;
        })
        .catch(() => {
          loadPromise = null;
          return null;
        });

      const competition = await loadPromise;
      if (competition && !cancelled) {
        checkIfWinner(competition, projectId);
      }
    };

    checkWinner();

    return () => {
      cancelled = true;
    };
  }, [projectId, i18n.language]);

  return { isWinner, position };
};
import { useEffect, useState } from 'react';
import { Competition, CompetitionAPI, API } from '@brg/api';
import { useTranslation } from 'react-i18next';

const ZHAR_KNIGA_COMPETITION_ID = '19624f65f36f414abed3891529626052';

let cachedCompetition: Competition | null = null;
let loadPromise: Promise<Competition | null> | null = null;

export const useZharKnigaWinner = (projectId?: string) => {
  const [isWinner, setIsWinner] = useState(false);
  const [position, setPosition] = useState<number | undefined>(undefined);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!projectId) return;

    let cancelled = false;

    const checkIfWinner = (competition: Competition, id: string) => {
      // @ts-ignore
      const winnerPositions = competition?.nominations?.[0]?.winnerPositions || [];
      const winner = winnerPositions.find((w: { winnerId: string; position?: number }) => w.winnerId === id);

      if (winner) {
        setIsWinner(true);
        setPosition(winner.position);
      } else {
        setIsWinner(false);
        setPosition(undefined);
      }
    };

    const checkWinner = async () => {
      if (cachedCompetition) {
        if (!cancelled) checkIfWinner(cachedCompetition, projectId);
        return;
      }

      if (loadPromise) {
        const competition = await loadPromise;
        if (competition && !cancelled) checkIfWinner(competition, projectId);
        return;
      }

      loadPromise = CompetitionAPI.Get({ idCompetition: ZHAR_KNIGA_COMPETITION_ID })
        .then((r) => r.json())
        .then((v) => API.toLang<Competition>(v, i18n.language))
        .then((competition) => {
          cachedCompetition = competition;
          loadPromise = null;
          return competition;
        })
        .catch(() => {
          loadPromise = null;
          return null;
        });

      const competition = await loadPromise;
      if (competition && !cancelled) {
        checkIfWinner(competition, projectId);
      }
    };

    checkWinner();

    return () => {
      cancelled = true;
    };
  }, [projectId, i18n.language]);

  return { isWinner, position };
};
